export default [
  '$scope', '$window', 'UserDataService',
  class CobrandAdminCtrl {
    constructor($scope, $window, UserDataService) {
      this._$scope = $scope;
      this._$window = $window;
      this._userDataService = UserDataService;
      this._checkIfUserLoggedIn();
      this._initEvents();
    }

    _checkIfUserLoggedIn() {
      this._userDataService.getUserData()
        .then(res => {
          if(res.user.roles !== 'COBRAND-ADMIN') {
             this._$window.location.href = '/';
          }
        })
        .catch(err => this._$window.location.href = '/login?returnUrl=%2Fcobrand-admin');
    }

    _initEvents() {
      this._$scope.$on('logout:success', () => {
        this._$window.location.href = '/';
      })
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/pages/cobrand/cobrand-admin/cobrand-admin.ctrl.js